import React, { useState, useEffect, forwardRef } from "react";
import "../../css/small-article.scss";

const Quote = forwardRef(({ quote, x }, ref) => {
  const [top, setTop] = useState();
  useEffect(() => {
    setTop((quote.y || Math.random()) * window.innerHeight * 0.8);
  }, []);
  return (
    <blockquote
      className="quote"
      style={{
        position: "absolute",
        left: x(new Date(quote.date)),
        top: window.innerHeight * 0.1 + top,
      }}
      ref={ref}
    >
      {quote.text}
      <cite>{quote.from}</cite>
    </blockquote>
  );
});

export default Quote;
